import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useState } from 'react';
import './Container.less';
import BaseContainer from '../components/BaseContainer';
import Footer from '~/components/FooterForPC';
import Header from '~/components/HeaderForPC';
import { getSiteInstance } from '~/common/services/siteData';
import { parseQuery } from '~/common/utils';
import { getSpecFont, getSpecFontForNews } from '~/utils/fontClass/index';

export default function Container() {
  const { i18n } = useTranslation();
  const [newsDetail, setNewsDetail] = useState<any>({});
  const initData = useCallback(async () => {
    const query = parseQuery();
    if (!query.id) {
      return;
    }
    const data = await getSiteInstance().getNewsDetail({
      id: query.id
    });
    const bigTitle = data?.title.toLocaleUpperCase();
    setNewsDetail({ ...data, bigTitle });
  }, []);
  useEffect(() => {
    initData();
  }, [initData]);
  return (
    <BaseContainer>
      <Header />
      <div styleName="privacy_banner">
        <div styleName="title" className={getSpecFont(i18n.language)}>
          {newsDetail?.bigTitle}
        </div>
      </div>
      <div
        styleName="privacy_contain"
        className={getSpecFontForNews(i18n.language, false)}
        dangerouslySetInnerHTML={{ __html: newsDetail?.content || '' }}
      ></div>
      <Footer />
    </BaseContainer>
  );
}
